export default __webpack_public_path__ + "38a5b9645b1f977ba38f5fbf158e3d85.png";